import api from '@synergycms_core/utils/api';
import { List, Map, fromJS } from 'immutable';
//import { is } from 'ramda';
// import actions from '../actions';
import hotelsActions from '@synergycms_core/store/hotels/hotelsActions';
import { mergeAll, contains, filter, forEach, keys } from 'ramda';
import { isUsDomain } from '@synergycms_core/utils/utils';

export const ESTABLISHMENT_TYPE_APARTMENT = 4;
export const ESTABLISHMENT_TYPE_HOTEL = 2;

export default {
  ...hotelsActions,
  GET: (hotelIds = []) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'params', 'params', 'hotelId']);
      if (!hotelIds.size) hotelIds = store.getIn(['customer', 'params', 'params', 'hotels'], List());

      if (hotelId && !hotelIds.find((id) => id === hotelId)) {
        hotelIds = hotelIds.push(hotelId);
      }

      const hotels = store.get('hotels');
      let queryHotels = List();
      if (hotelIds && hotelIds.size) {
        hotelIds.forEach((id) => {
          if (!hotels.getIn([parseInt(id, 10), 'id']) || !hotels.getIn([id, 'id'])) {
            queryHotels = queryHotels.push(id);
          }
        });

        if (queryHotels.size) {
          const hotels_info = store.getIn(['hotels', 'hotels_info', 'hotels'], List());
          const selectedHotels = hotelIds.reduce(function (response, hotelId) {
            const hotelInfo = hotels_info.find((h) => h.get('id') === parseInt(hotelId));
            return hotelInfo ? response.set(hotelId, hotelInfo) : response;
          }, Map());

          if (selectedHotels.size && selectedHotels.size === hotelIds.size) {
            return Promise.resolve(selectedHotels);
          } else {
            return false;
            //return dispatch(hotelsActions.getAsync(hotelIds));
          }
        }
      }
    };
  },
  GET_ASYNC: (hotelIds = []) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'params', 'params', 'hotelId']);
      if (!hotelIds.size) hotelIds = store.getIn(['customer', 'params', 'params', 'hotels'], List());

      if (hotelId && !hotelIds.find((id) => id === hotelId)) {
        hotelIds = hotelIds.push(hotelId);
      }
      const generalError = (queryHotels) => {
        //dispatch(actions.notifications.send('error', '_%error al recuperar la disponibilidad%_'));
        return Promise.resolve(
          queryHotels.reduce((response, hotelId) => response.set(hotelId, Map({ success: false })), Map())
        );
      };
      const hotels = store.get('hotels');
      let queryHotels = List();
      if (hotelIds && hotelIds.size) {
        hotelIds.forEach((id) => {
          if (!hotels.getIn([parseInt(id, 10), 'id']) || !hotels.getIn([id, 'id']) || !hotels.getIn([id, 'success'])) {
            queryHotels = queryHotels.push(id);
          }
        });
        if (queryHotels.size) {
          return api
            .get({
              path: `descriptives`,
              fullFiled: () => {
                const hotels = getState().get('hotels');
                const hotelss = hotelIds.reduce(function (previous, key) {
                  return hotels.get(key) && hotels.getIn([key, 'success'])
                    ? previous.set(key, hotels.get(key))
                    : previous;
                }, Map());
                return hotelss.size && hotelIds.size === hotelss.size && hotelss;
              },
              store: ({ store, request }) => {
                const ids = keys(store);
                const requestdHotels = queryHotels.toJS();

                const filteredRequest = filter((key) => {
                  return !contains(key?.toString(), ids);
                }, requestdHotels);

                const res = [];
                let initRequest;
                if (filteredRequest.length) {
                  initRequest = request({ q: 'hotels:' + filteredRequest.join(';') });
                }

                forEach((id) => {
                  if (contains(id, filteredRequest)) {
                    store[id] = initRequest;
                    res.push(initRequest);
                  } else {
                    res[id] = store[id];
                    res.push(initRequest);
                  }
                }, requestdHotels);
                return Promise.all(res).then((res) => {
                  return mergeAll(res);
                });
              }
            })
            .then((hotelsData) => {
              if (hotelsData.success !== false) {
                const newHotelsData = fromJS(hotelsData);
                return newHotelsData.reduce((newObjHotels, hotel, hotelId) => {
                  let mergedHotel;
                  const success = !!hotel?.get?.('id');

                  if (success) {

                    if(isUsDomain()){
                      if(hotel.get('country_iso_code') === 'US') {
                        hotel = hotel.set('stars', '')
                      }
                    }
                    
                    const hotelInfo = store
                      .getIn(['hotels', 'hotels_info', 'hotels'])
                      .find((h) => h.get('id') === parseInt(hotelId));
                    mergedHotel = hotelInfo && hotelInfo.merge(hotel);
                  } else {
                    mergedHotel = hotel;
                  }
                  return mergedHotel ? newObjHotels.set(hotelId, mergedHotel.set('success', success)) : newObjHotels;
                }, Map());
              } else {
                return generalError(queryHotels);
              }
            })
            .catch((err) => {
              return generalError(queryHotels);
            });
        }
      }
      return Promise.resolve();
    };
  },
  SET_LAST_QUERY_PARAMS: (hotelParams) => {
    return hotelParams;
  },
  SEND_CONFIRMATION_GUEST: (hotelId) => (dispatch, getState) => {
    const store = getState();
    const reservation = store.getIn(['customer', 'reservation']);
    const trackingId = reservation.get('tracking_id');
    const pinCode = reservation.get('pin_code');

    const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];
    return api.get(`cms/send_confirmation_guest/${trackingId}`, {}, hotelId, extraHeaders).then((response) => {
      return response;
    });
  }
};
